import React from "react"

import { RadioCpfCnpj } from "@atos6/components"
import { useStore } from "../containers"

export function RadioCpfCnpjStateful() {
  const { documentType, setState } = useStore()

  return (
    <RadioCpfCnpj
      value={documentType}
      onChange={documentType => setState({ documentType })}
    />
  )
}
